import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState, useMemo, useEffect } from 'react';
import debounce from 'lodash.debounce';
import { KlevuDomEvents, KlevuFetch, KlevuKMCSettings, KlevuLastSearches, KlevuResultEvent, KlevuTypeOfRecord, personalisation, search, suggestions, trendingProducts, FilterManager, listFilters, applyFilterWithManager, sendSearchEvent, overrideSettings } from '@klevu/core';
import { fieldSearchLoggedIn, fieldSearchNonLoggedIn, KLEVU_FORMAT_PRODUCTS } from '../../overrides/venia-ui/components/SearchPage/klevuSearchFields';
var clickManager;
var categoryClickManager;
var productClickManager;
var manager = new FilterManager();
export var useKlevuSearch = function useKlevuSearch(_ref) {
  var isSignedIn = _ref.isSignedIn,
      customerGroupId = _ref.customerGroupId,
      _ref$props = _ref.props,
      props = _ref$props === void 0 ? {
    enablePersonalisation: true
  } : _ref$props;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      searchValue = _useState2[0],
      setSearchValue = _useState2[1];

  var _useState3 = useState(KlevuLastSearches.get()),
      _useState4 = _slicedToArray(_useState3, 2),
      lastSearches = _useState4[0],
      setLastSearches = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      trendProducts = _useState6[0],
      setTrendingProducts = _useState6[1];

  var _useState7 = useState(),
      _useState8 = _slicedToArray(_useState7, 2),
      kmcSettings = _useState8[0],
      setKmcSettings = _useState8[1];

  var _useState9 = useState({
    items: [],
    meta: {}
  }),
      _useState10 = _slicedToArray(_useState9, 2),
      products = _useState10[0],
      setProducts = _useState10[1];

  var _useState11 = useState([]),
      _useState12 = _slicedToArray(_useState11, 2),
      sugs = _useState12[0],
      setSuggestions = _useState12[1];

  var _useState13 = useState([]),
      _useState14 = _slicedToArray(_useState13, 2),
      categories = _useState14[0],
      setCategories = _useState14[1];

  var _useState15 = useState([]),
      _useState16 = _slicedToArray(_useState15, 2),
      banners = _useState16[0],
      setBanners = _useState16[1];

  var onSearchChange = function onSearchChange(event) {
    var _event$target;

    if (event && event !== null && event !== void 0 && event.target && event !== null && event !== void 0 && (_event$target = event.target) !== null && _event$target !== void 0 && _event$target.value) {
      setSearchValue(event.target.value);
      debouncedChangeHandler(event.target.value);
    } else if (event === undefined) {
      setSearchValue('');
      debouncedChangeHandler('');
    } else {
      setSearchValue('');
      debouncedChangeHandler('');
    }
  }; // Note the "-" bevore (hf_is_outlet - designates negation
  // const searchModifiers = props.enablePersonalisation ? [personalisation(), overrideSettings({'customANDQuery': '-(klevu_category:"Outlet") OR -(hf_is_outlet:"Yes")'})] : [];


  var searchModifiers = props.enablePersonalisation ? [personalisation(), overrideSettings({
    customANDQuery: '-(klevu_category:"Outlet")'
  })] : [];

  var doSearch = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(term) {
      var _searchResult$records, _result$suggestionsBy, _result$suggestionsBy2, _result$queriesById;

      var result, searchResult, categoryResult, productsResults, suggestionsResult, categoriesResult;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(term.length < 3)) {
                _context.next = 4;
                break;
              }

              setProducts({
                items: [],
                meta: {}
              });
              setSuggestions([]);
              return _context.abrupt("return");

            case 4:
              _context.next = 6;
              return KlevuFetch(search.apply(void 0, [term, {
                limit: 8,
                typeOfRecords: [KlevuTypeOfRecord.Product],
                priceFieldSuffix: customerGroupId ? "USD-".concat(customerGroupId === null || customerGroupId === void 0 ? void 0 : customerGroupId.split(':')[0]) : null,
                fields: isSignedIn ? fieldSearchLoggedIn : fieldSearchNonLoggedIn
              }].concat(searchModifiers)), search(term, {
                id: 'categories',
                limit: 5,
                typeOfRecords: [KlevuTypeOfRecord.Category],
                fields: ['id', 'name', 'url', 'typeOfRecord', 'itemGroupId'],
                groupBy: 'name'
              }), suggestions(term, {
                id: 'suggestions',
                typeOfQuery: 'AUTO_SUGGESTIONS',
                limit: 3,
                query: term
              }));

            case 6:
              result = _context.sent;
              searchResult = result.queriesById('search');
              clickManager = searchResult === null || searchResult === void 0 ? void 0 : searchResult.getSearchClickSendEvent();
              categoryResult = result.queriesById('categories');
              categoryClickManager = categoryResult === null || categoryResult === void 0 ? void 0 : categoryResult.getSearchClickSendEvent();
              productsResults = searchResult === null || searchResult === void 0 ? void 0 : (_searchResult$records = searchResult.records) === null || _searchResult$records === void 0 ? void 0 : _searchResult$records.map(function (r) {
                var imageUrl = r.imageUrl.split('/needtochange');
                return _objectSpread(_objectSpread({}, r), {}, {
                  // imageUrl: r.imageUrl.replace(process.env.MAGENTO_BACKEND_URL + '/needtochange', ''),
                  imageUrl: imageUrl[0] + imageUrl[1],
                  url: r.url.replace(process.env.MAGENTO_BACKEND_URL, ''),
                  clickManager: clickManager
                });
              });
              setProducts(productsResults ? {
                items: productsResults,
                meta: searchResult === null || searchResult === void 0 ? void 0 : searchResult.meta
              } : []);
              suggestionsResult = (_result$suggestionsBy = result.suggestionsById('suggestions')) === null || _result$suggestionsBy === void 0 ? void 0 : (_result$suggestionsBy2 = _result$suggestionsBy.suggestions.map(function (i) {
                return i.suggest;
              })) === null || _result$suggestionsBy2 === void 0 ? void 0 : _result$suggestionsBy2.filter(function (sug) {
                var _sug$replace;

                return (sug === null || sug === void 0 ? void 0 : (_sug$replace = sug.replace(/<b>/g, '')) === null || _sug$replace === void 0 ? void 0 : _sug$replace.replace(/<\/b>/g, '')) !== term;
              });
              setSuggestions(suggestionsResult ? suggestionsResult : []);
              categoriesResult = (_result$queriesById = result.queriesById('categories')) === null || _result$queriesById === void 0 ? void 0 : _result$queriesById.records.map(function (r) {
                return {
                  id: r.id,
                  name: r.name,
                  url: r.url.replace(process.env.MAGENTO_BACKEND_URL, ''),
                  clickManager: categoryClickManager
                };
              });
              setCategories(categoriesResult ? categoriesResult : []);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function doSearch(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var debouncedChangeHandler = useMemo(function () {
    return debounce(doSearch, 300);
  }, [isSignedIn, customerGroupId]);

  var fetchEmptySuggestions = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var klevuApiKey, res, _result$records, result, trendingProductsResult;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              handleLastSearchesUpdate();
              klevuApiKey = kmcSettings === null || kmcSettings === void 0 ? void 0 : kmcSettings.klevu_cmsApiKey;
              _context2.next = 4;
              return KlevuFetch(trendingProducts.apply(void 0, [{
                limit: 8,
                typeOfRecords: [KlevuTypeOfRecord.Product],
                priceFieldSuffix: customerGroupId ? "USD-".concat(customerGroupId === null || customerGroupId === void 0 ? void 0 : customerGroupId.split(':')[0]) : null,
                fields: isSignedIn ? fieldSearchLoggedIn : fieldSearchNonLoggedIn
              }].concat(searchModifiers)));

            case 4:
              res = _context2.sent;

              if (res) {
                result = res.queriesById('trendingProducts');
                clickManager = result === null || result === void 0 ? void 0 : result.getSearchClickSendEvent();
                trendingProductsResult = result === null || result === void 0 ? void 0 : (_result$records = result.records) === null || _result$records === void 0 ? void 0 : _result$records.map(function (r) {
                  var imageUrl = r.imageUrl.split('/needtochange');
                  return _objectSpread(_objectSpread({}, r), {}, {
                    imageUrl: imageUrl[0] + imageUrl[1],
                    url: r.url.replace(process.env.MAGENTO_BACKEND_URL, ''),
                    clickManager: clickManager
                  });
                });
                setTrendingProducts(trendingProductsResult ? trendingProductsResult : []);
              }

              _context2.next = 8;
              return fetch("https://js.klevu.com/klevu-js-v1/klevu-js-api/".concat(klevuApiKey, "-banner.json")).then(function (res) {
                return res.json();
              }).then(function (result) {
                setBanners(result !== null && result !== void 0 && result.klevu_banner ? result === null || result === void 0 ? void 0 : result.klevu_banner : []);
              }, function (error) {
                console.log(error);
              });

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function fetchEmptySuggestions() {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleLastSearchesUpdate = function handleLastSearchesUpdate() {
    setLastSearches(Array.from(KlevuLastSearches.get()).reverse());
  };

  useEffect(function () {
    fetchKMCSettings();
    return function () {
      debouncedChangeHandler.cancel();
    };
  }, []);

  var fetchKMCSettings = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var settings;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return KlevuKMCSettings();

            case 2:
              settings = _context3.sent;
              setKmcSettings(settings.root);

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function fetchKMCSettings() {
      return _ref4.apply(this, arguments);
    };
  }();

  var params = {
    // ...focusParams,
    onFocus: function onFocus(event) {
      // focusParams.onFocus(event);
      fetchEmptySuggestions();
    }
  };
  var transformedProductsArray = useMemo(function () {
    return KLEVU_FORMAT_PRODUCTS(products, customerGroupId ? "USD-".concat(customerGroupId === null || customerGroupId === void 0 ? void 0 : customerGroupId.split(':')[0]) : null);
  }, [products, customerGroupId]);
  var transformedTrendingProducts = useMemo(function () {
    return KLEVU_FORMAT_PRODUCTS({
      items: trendProducts
    }, customerGroupId ? "USD-".concat(customerGroupId === null || customerGroupId === void 0 ? void 0 : customerGroupId.split(':')[0]) : null);
  }, [trendProducts, customerGroupId]);
  return {
    params: params,
    onSearchChange: onSearchChange,
    searchValue: searchValue,
    setSearchValue: setSearchValue,
    products: {
      items: transformedProductsArray,
      meta: products === null || products === void 0 ? void 0 : products.meta
    },
    categories: categories,
    suggestions: sugs,
    doSearch: doSearch,
    trendingProducts: transformedTrendingProducts,
    settings: kmcSettings,
    debouncedChangeHandler: debouncedChangeHandler,
    banners: banners,
    lastSearches: lastSearches
  };
};